import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  accordionContainer: {
    [theme.breakpoints.down('lg')]: {
      borderRadius: '12px',
      padding: '0 12px 0 12px',
      '&.Mui-expanded': {
        padding: '0 12px 8px 12px',
      },
    },
  },
  accordionSummary: {
    [theme.breakpoints.down('lg')]: {
      padding: '0px',
      '& .MuiAccordionSummary-content': {
        justifyContent: 'flex-start',
        margin: '0px',
      },
    },
  },
  cardItemValue: {
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.875rem',
    },
  },
  cardItemLabel: {
    [theme.breakpoints.down('lg')]: {
      color: theme.new.color.grey[600],
      fontSize: '0.875rem',
    },
  },
  cardItemContainer: {
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: '8px 0px',
      borderTop: `1px solid ${theme.new.color.line.hairline}`,
    },
  },
  assetListCardContent: {
    '&:last-child': {
      [theme.breakpoints.down('md')]: {
        paddingBottom: '16px',
      },
    },
    '& .MuiCheckbox-root': {
      '& svg': {
        fill: theme.new.color.border,
        backgroundColor: theme.new.color.background.input,
      },

      '&.Mui-checked': {
        '& .MuiSvgIcon-root': {
          fill: theme.new.color.brandPrimary,
        },
      },
    },
  },
  assetCardItemLabel: {
    [theme.breakpoints.down('md')]: {
      color: theme.new.color.grey[600],
      fontSize: '0.875rem',
    },
  },
  assetCardItemValue: {
    [theme.breakpoints.down('md')]: {
      fontSize: '0.875rem',
    },
  },
  assetCardItemContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      marginBottom: '8px',
    },
  },
  rowActionButtonContainer: {
    '& button': {
      paddingRight: 0,
    },
  },
}));

export default useStyles;
